export default {
  show: false,
  type: 'error',
  message: 'Ops! Algo não funcionou como previsto.'
}



// WEBPACK FOOTER //
// ./src/store/modules/messages/state.js